// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@mantine/core';
import { useMantineTheme } from '@mantine/core';
import { Container, Stack } from '@/components/ui/layout';
import { Title, Text, Button, Anchor, Badge } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { IconMail, IconArrowLeft, IconSparkles } from '@tabler/icons-react';
import { FadeIn, SlideIn } from '@/components/animations';

export default function ForgotGlassmorphism() {
  const [email, setEmail] = useState('');
  const theme = useMantineTheme();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Password reset for:', email);
  };

  return (
    <Box
      style={{
        minHeight: '100vh',
        backgroundImage: 'url(https://images.unsplash.com/photo-1579546929518-9e396f3cc809?w=1920&q=80)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
      }}
    >
      <Box
        style={{
          position: 'absolute',
          inset: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.3)',
          backdropFilter: 'blur(8px)',
        }}
      />

      <Box mih="100vh" py="xl" px="md" style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center' }}>
        <Container size="xs" w="100%">
          <SlideIn direction="up" delay={100}>
            <Box
              style={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(20px) saturate(180%)',
                border: '1px solid rgba(255, 255, 255, 0.2)',
                borderRadius: theme.radius.lg,
                padding: '2.5rem',
                boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)',
              }}
            >
              <Stack gap="lg">
                <Button
                  component={Link}
                  to="/app/demo/auth-pages/forgot-password"
                  variant="subtle"
                  size="xs"
                  leftSection={<IconArrowLeft size={14} />}
                  w="fit-content"
                  c="white"
                >
                  Back to variants
                </Button>

                <FadeIn delay={200}>
                  <Stack gap="xs" align="center">
                    <Badge
                      leftSection={<IconSparkles size={12} />}
                      variant="white"
                      size="lg"
                      style={{
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.3)',
                      }}
                    >
                      Glassmorphism
                    </Badge>
                    <Title order={2} ta="center" c="white" mt="md">
                      Forgot password?
                    </Title>
                    <Text c="white" size="sm" ta="center" style={{ opacity: 0.9 }}>
                      Enter your email and we'll send you a reset link
                    </Text>
                  </Stack>
                </FadeIn>

                <SlideIn direction="up" delay={300}>
                  <form onSubmit={handleSubmit}>
                    <Stack gap="md">
                      <TextInput
                        label="Email address"
                        placeholder="you@example.com"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        leftSection={<IconMail size={16} />}
                        required
                        styles={{
                          label: { color: 'white', fontWeight: 500 },
                          input: {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: 'white',
                            '&::placeholder': { color: 'rgba(255, 255, 255, 0.6)' },
                            '&:focus': { borderColor: 'rgba(255, 255, 255, 0.4)' },
                          },
                        }}
                      />

                      <Button
                        type="submit"
                        fullWidth
                        size="md"
                        variant="white"
                        style={{
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                          backdropFilter: 'blur(10px)',
                        }}
                      >
                        Send reset link
                      </Button>
                    </Stack>
                  </form>
                </SlideIn>

                <FadeIn delay={400}>
                  <Text size="sm" ta="center" c="white" style={{ opacity: 0.9 }}>
                    Remember your password?{' '}
                    <Anchor component={Link} to="/app/demo/auth-pages/login/glassmorphism" fw={500} c="white">
                      Sign in
                    </Anchor>
                  </Text>
                </FadeIn>
              </Stack>
            </Box>
          </SlideIn>
        </Container>
      </Box>
    </Box>
  );
}
